<template lang="html">
	<div class="compare" v-show="showCompare">
		<div class="overlay">
			<div class="top-content">
				<div class="clearfix">
					<div class="f-l main-title">COMPARE QUOTATIONS</div>
					<div
						class="close-modal f-r"
						@click="$store.commit('showCompare', false)"
					>
						<i class="fa fa-times"></i>
					</div>
					<div class="close-modal f-r mr-2" @click="clearCompare()">
						<i class="fa fa-broom"></i>
					</div>
				</div>
			</div>

			<div class="no-content" v-if="compare_items.length == 0">
				<div class="title">No Comparison Quotations Found</div>
			</div>
			<div class="area" v-if="compare_items.length > 0">
				<scrollbar>
					<div
						class="sc-content clearfix"
						:style="`width: ${compare_items.length * 340 + 20}px`"
					>
						<div
							class="quotation-card f-l"
							v-for="(quotation, i) of compare_items"
							:key="i"
						>
							<div class="remove-quotation">
								<div
									class="close-btn"
									@click="removeCompareItem(i)"
								>
									<i class="fa fa-times"></i>
								</div>
							</div>
							<div class="clearfix">
								<div class="image-box f-l">
									<img
										v-if="
											quotation.product_logo &&
											quotation.product_logo.trim !== ''
										"
										:src="`${gateway}${quotation.product_logo}`"
										alt=""
										class="image"
									/>
									<img
										v-else
										src="/img/logo-1.png"
										alt=""
										class="image"
									/>
								</div>
								<div class="right-content f-l">
									<div class="title">
										{{ quotation.product_name }}
									</div>
									<div class="offer-box">
										<!-- <div class="regular">Regular Price: <span class="strikethrough">KES {{utils.numberWithCommas(54000)}}</span></div> -->
										<div class="offer tx-red">
											Premium :
											{{
												utils.numberWithCommas(
													quotation.premium,
												)
											}}
										</div>
										<!-- <div class="save">You Save: KES {{utils.numberWithCommas(54000 - 22000)}}</div> -->
									</div>
								</div>
							</div>
							<div class="ratings clearfix">
								<Rate
									class="f-l rate"
									disabled
									:allow-half="true"
									v-model="quotation.rating"
								/>
								<div class="reviews f-l">(29 Reviews)</div>
								<div class="icon f-l"></div>
							</div>
							<div class="prod-rate">
								Rate: {{ quotation.rateDetails[0].rate_value }}%
							</div>
							<div class="underwritter">
								{{ quotation.underwritter_name }}
							</div>
							<div class="desc">{{ quotation.description }}</div>
							<div class="benefits">
								<div class="small-title">Benefits</div>
								<div
									class="features clearfix"
									v-if="quotation.product_benefits"
									v-for="(
										benefit, i
									) of quotation.product_benefits"
									:key="i"
								>
									<div class="icon f-l">
										<div class="fa fa-check"></div>
									</div>
									<div class="name f-l">
										{{
											benefit.benefit.name ||
											'Not Provided'
										}}
									</div>
								</div>
							</div>
							<div class="clearfix">
								<!-- <div class="actions f-r">
                           <i class="fa fa-bookmark"></i>
                           <i class="fa fa-shopping-cart"></i>
                        </div> -->
							</div>
						</div>
					</div>
				</scrollbar>
			</div>
		</div>
	</div>
</template>

<script>
import compare from './compare.store';
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	beforeDestroy() {
		this.$store.unregisterModule('compare');
	},
	created() {
		utils.registerModule('compare', compare, this.$store);
	},
	components: {
		scrollbar: VueScrollbar,
		Rate: () => import('@/libs/clarks/components/rate/'),
	},
	computed: {
		...mapGetters(['compare_items', 'showCompare']),
	},
	data() {
		return {
			utils,
			gateway: process.env.VUE_APP_GATEWAY,
			show_cover_type: true,
			show_premium_range: false,
			show_insurer: false,
		};
	},
	methods: {
		...mapActions([
			'fetchCompareItems',
			'clearCompare',
			'removeCompareItem',
		]),
		close() {
			Event.$emit('compare:close', { compare: false });
		},
	},
	async mounted() {
		utils.registerModule('compare', compare, this.$store);
		await this.fetchCompareItems();
	},
};
</script>

<style lang="less">
.compare {
	.overlay {
		-webkit-backdrop-filter: blur(1px);
		backdrop-filter: blur(1px);
		background-color: rgba(0, 0, 0, 0.7);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1200;
		overflow-y: auto;

		.close-btn {
			cursor: pointer;
			position: absolute;
			right: 10px;

			&:hover {
				color: var(--ne-red);
			}
		}
		.no-content {
			background: var(--white);
			border-radius: 4px;
			border: solid 1px #e6eaee;
			padding: 40px 0;
			text-align: center;
			font-size: 14px;
			margin: 40px 20px;
			font-weight: 600;
			color: var(--ne-red);
		}
		.top-content {
			padding: 20px;

			.main-title {
				color: var(--ne-yellow);
				font-weight: 600;
				font-size: 18px;
				margin: 10px 0 0 0;
			}
		}
	}

	.area {
		padding: 0 0 30px 0;
		position: absolute;
		z-index: 1500;
		left: 0;
		right: 0;
		top: 80px;
		bottom: 20px !important;

		.sc-content {
			width: auto;
			min-width: 100vw;
			display: flex;
		}
		.quotation-card {
			background: var(--white);
			border-radius: 3px;
			padding: 10px;
			width: 340px;
			margin: 0 10px 0 10px;
			padding-bottom: 90px;
			position: relative;

			.prod-rate {
				color: var(--ne-green);
				font-weight: 600;
				font-size: 12px;
			}
			.features {
				margin: 3px 0;
				font-size: 13px;
				color: #a7abbd;

				.name {
				}
				.icon {
					margin: 2px 10px 0 0;
					font-size: 12px;
				}
			}
			.actions {
				position: absolute;
				bottom: 20px;
				right: 0;

				.fa {
					margin: 20px 10px;
					cursor: pointer;

					&:hover {
						color: var(--primary);
					}
				}
			}
			.right-content {
				width: calc(100% - 120px);
			}
			.offer-box {
				text-align: left;
				margin: 0 15px 0 0;

				.regular {
					color: var(--text-grey);
					font-family: var(--font-bold);
					font-size: 13px;
				}
				.offer {
					font-size: 16px;
					font-family: var(--font-bold);
				}
				.save {
					font-size: 12px;
					color: var(--text-grey);
				}
			}
			.ratings {
				margin: 20px 0 0 0;

				.reviews {
					color: #7f8fa4;
					font-size: 13px;
				}
				.rate {
					font-size: 13px !important;
				}
			}
			.image-box {
				text-align: center;

				.image {
					height: auto;
					width: auto;
					max-height: 110px;
					max-width: 110px;
					margin: 0 10px 0 0;
					transition: all 1s ease-in;
				}
			}
			.title {
				font-size: 15px;
				font-weight: 600;
				color: var(--primary);
				margin: 5px 0 0 0;
			}
			.benefits {
				bottom: 30px;
			}
			.desc {
				font-size: 13px;
				height: 60px;
				white-space: initial;
				overflow: hidden;
				text-overflow: ellipsis;
				margin: 3px 0 0 0;
			}

			.underwritter {
				font-size: 13px;
				font-weight: 600;
				color: var(--primary);
			}
		}
	}
}
</style>
